import { axiosInstance } from './common';

export const getManifest = () =>
  axiosInstance.get('/docs').then((r) => r.data);

export const getArticle = (slug) =>
  axiosInstance.get(`/docs/${slug}`).then((r) => r.data);
